import axios from 'axios'
import modulesDriversLoader from '../services/ModulesDriversLoader'

export default class EntityManagementService {
    constructor() {
        modulesDriversLoader.load().then(({ getApiRoutes }) => {
            this.apiRotues = { ...getApiRoutes() }
        })
    }

    async fetchEntitesList(params = {}) {
        const response = await axios.get(
            `${this.apiRotues.API_BASE_URL}/entity_management/legal/list`,
            {
                params: params,
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem(
                        'LOCAL_STORAGE_KEY_ACCESS_TOKEN'
                    )}`
                }
            }
        )

        return response.data?.data || []
    }

    async fetchTotalEntities(params = {}) {
        const response = await axios.get(
            `${this.apiRotues.API_BASE_URL}/entity_management/legal/parents`,
            {
                params: params,
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem(
                        'LOCAL_STORAGE_KEY_ACCESS_TOKEN'
                    )}`
                }
            }
        )

        return response.data?.data || []
    }

    async create(payload = {}) {
        const response = await axios.post(
            `${this.apiRotues.API_BASE_URL}/entity_management/legal/add`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem(
                        'LOCAL_STORAGE_KEY_ACCESS_TOKEN'
                    )}`
                }
            }
        )

        return response.data?.data
    }

    async delete(entityId) {
        const response = await axios.delete(
            `${this.apiRotues.API_BASE_URL}/entity_management/legal/remove/${entityId}`,
            {
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem(
                        'LOCAL_STORAGE_KEY_ACCESS_TOKEN'
                    )}`
                }
            }
        )

        return response.data.data
    }

    async forceDelete(entityId) {
        const response = await axios.delete(
            `${this.apiRotues.API_BASE_URL}/entity_management/legal/force_remove/${entityId}`,
            {
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem(
                        'LOCAL_STORAGE_KEY_ACCESS_TOKEN'
                    )}`
                }
            }
        )

        return response.data.data
    }

    async show(entityId, params = {}) {
        const response = await axios.get(
            `${this.apiRotues.API_BASE_URL}/entity_management/legal/show/${entityId}`,
            {
                params: params,
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem(
                        'LOCAL_STORAGE_KEY_ACCESS_TOKEN'
                    )}`
                }
            }
        )

        return response.data?.data || {}
    }

    async edit(entityId, payload = {}) {
        const response = await axios.post(
            `${this.apiRotues.API_BASE_URL}/entity_management/legal/edit/${entityId}`,
            payload,
            {
                headers: {
                    Authorization: `Bearer ${window.localStorage.getItem(
                        'LOCAL_STORAGE_KEY_ACCESS_TOKEN'
                    )}`
                }
            }
        )

        return response.data?.data
    }

    async uploadExcel(formData) {
        const response = await axios.post(
            `${this.apiRotues.API_BASE_URL}/entity_management/legal/add_bulk`, 
            formData, 
            {
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                }
            }
        )

        return response.data.data
    }

    downloadExcelTemplate(options = {}, cancelToken = undefined, onDownloadProgress = undefined) {
        return axios.get(
            `${this.apiRotues.API_BASE_URL}/entity_management/legal/template`,
            {
                responseType: 'blob',
                headers: {
                    Authorization: `Bearer ${localStorage.getItem(
                        "LOCAL_STORAGE_KEY_ACCESS_TOKEN"
                    )}`
                },
                onDownloadProgress: options?.onDownloadProgress || undefined,
                cancelToken: options?.cancelToken || undefined,
            }
        )
    }
}
